<template>
  <div class="appraisal__form">
    <div class="appraisal__search-type">
      <button :class="this.form.addressSearch ? 'appraisal__search-type--selected' : ''" @click="selectType(true)">
        Buscar por dirección
      </button>
      <button :class="!this.form.addressSearch ? 'appraisal__search-type--selected' : ''" @click="selectType(false)">
        Buscar por ref. catastral
      </button>
    </div>
    <FormulateForm ref="form" v-model="form" :errors="formErrors" :schema="schema" @submit="openProperties" />
    <Popup
      v-if="popupStep"
      :title="popupTitle"
      :subtitle="popupSubtitle"
      :color="popupColor"
      :modifier-class="popupStep"
      :showCloseIcon="true"
      :showHeaderIcon="popupIcon"
      @closePopup="openPopup(null)"
    >
      <PropertySelect
        v-if="popupStep == PROPERTIES"
        :properties="propertiesData"
        :address="getAddressReference"
        :selectedProperty="propertyData"
        @nextStep="openFeatures"
        @closePopup="openPopup(null)"
      ></PropertySelect>
      <PropertyFeatures
        v-if="popupStep == FEATURES"
        :property="propertyData"
        :address="getAddressReference"
        :propertyTypes="types"
        :statusOptions="statuses"
        :roomAmount="rooms"
        :extras="extras"
        :selectedValues="form.extras"
        @nextStep="openReason"
        @prevStep="openPopup(PROPERTIES)"
        @closePopup="openPopup(null)"
      ></PropertyFeatures>
      <PropertyReason
        v-if="popupStep == REASON"
        :address="getAddressReference"
        :reasons="reasons"
        @submit="submitForm"
        @prevStep="openPopup(FEATURES)"
        @closePopup="openPopup(null)"
      ></PropertyReason>
    </Popup>
  </div>
</template>
<script>
import axios from 'axios';
import { loadGoogleMaps } from '@/web/util';
import { displayCustomIconToast } from '@/lego/utils/render/toast';
import Popup from '@/funnels/components/layout/Popup';
import PropertySelect from '@/web/appraisal/forms/PropertySelect';
import PropertyFeatures from '@/web/appraisal/forms/PropertyFeatures';
import PropertyReason from '@/web/appraisal/forms/PropertyReason';

const PROPERTIES = 'properties';
const FEATURES = 'features';
const REASON = 'reason';

export default {
  components: { Popup, PropertySelect, PropertyFeatures, PropertyReason },
  props: {
    types: {
      type: Object,
      required: true,
    },
    statuses: {
      type: Object,
      required: true,
    },
    rooms: {
      type: Object,
      required: true,
    },
    extras: {
      type: Object,
      required: true,
    },
    reasons: {
      type: Object,
      required: true,
    },
    towns: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: {
        address: null,
        ref: null,
        town: null,
        extras: null,
        property: null,
        reason: null,
        addressSearch: true,
      },
      PROPERTIES,
      FEATURES,
      REASON,
      formErrors: null,
      propertiesData: null,
      propertyData: null,
      popupStep: null,
      popupData: {
        [PROPERTIES]: {
          title: 'Selecciona el inmueble',
          subtitle: 'En esta dirección hay varios inmuebles, selecciona el que quieres valorar.',
          icon: false,
        },
        [FEATURES]: {
          title: 'Características del inmueble',
          subtitle: 'Todos los datos que puedas informar ayudarán a que la valoración sea más precisa.',
          icon: false,
        },
        [REASON]: {
          title: '¿Para qué quieres la valoración?',
          subtitle: 'De este modo podemos mostrarte los datos que más te interesan.',
          icon: false,
        },
      },
    };
  },
  watch: {
    'form.addressSearch': function(val) {
      if (val) {
        this.$nextTick(function() {
          this.mountGoogleAutocomplete();
        });
      }
    },
  },
  mounted() {
    this.mountGoogleAutocomplete();
  },
  computed: {
    popupTitle() {
      return this.popupStep ? this.popupData[this.popupStep].title : '';
    },
    popupSubtitle() {
      return this.popupStep ? this.popupData[this.popupStep].subtitle : null;
    },
    popupColor() {
      return 'moles--warning';
    },
    popupIcon() {
      return this.popupStep ? this.popupData[this.popupStep].icon : true;
    },
    getAddressReference() {
      return this.form.addressSearch ? this.form.address : this.form.ref;
    },
    submitField() {
      return {
        type: 'submit',
        name: 'submit',
        label: 'Valorar vivienda',
      };
    },
    buttons() {
      return {
        component: 'div',
        class: 'btn-container appraisal__button',
        children: [this.submitField],
      };
    },
    addressField() {
      return {
        component: 'div',
        id: 'addressField',
        children: [
          this.form.addressSearch
            ? {
                name: 'address',
                type: 'text',
                placeholder: 'Dirección y número',
                validation: 'required',
                'validation-messages': {
                  required: 'La dirección es obligatoria.',
                },
                '@input': this.fetchTown,
              }
            : {
                name: 'ref',
                type: 'text',
                placeholder: 'Referencia catastral',
                validation: 'required',
                'validation-messages': {
                  required: 'La referencia catastral es obligatoria.',
                },
                '@input': this.fetchTown,
              },
          {
            component: 'div',
            class: 'search-icon-wrapper',
            children: [
              {
                component: 'i',
                class: 'icon icon-xxxs icon-magnifying',
              },
            ],
          },
        ],
      };
    },
    townField() {
      return {
        name: 'town',
        type: 'triotecaSelect',
        placeholder: 'Municipio',
        options: this.towns,
        validation: 'required',
        'validation-messages': {
          required: 'El municipio es obligatorio.',
        },
      };
    },
    formFields() {
      return {
        component: 'div',
        id: this.form.addressSearch ? 'addressField' : 'referenceField',
        class: 'formulate-input-wrapper-search',
        children: [
          this.addressField,
          {
            component: 'div',
            class: 'formulate-input-wrapper-town',
            children: [this.townField, this.submitField],
          },
        ],
      };
    },
    schema() {
      return [this.formFields, this.buttons];
    },
  },
  methods: {
    selectType(val) {
      this.form.addressSearch = val;
    },
    openPopup(type) {
      this.popupStep = type;
    },
    openProperties() {
      this.formErrors = null;
      this.form.extras = null;
      this.form.reason = null;
      this.form.property = null;
      this.propertyData = null;

      axios
        .patch(window.location.pathname, this.form)
        .then(data => {
          this.setProperties(data);
          this.openPopup(PROPERTIES);
        })
        .catch(e => {
          this.formErrors = e.response?.data?.errors;
        });
    },
    openFeatures(property) {
      this.form.property = property.ref;
      this.propertyData = property;
      this.openPopup(FEATURES);
    },
    openReason(extras) {
      this.form.extras = extras;
      this.openPopup(REASON);
    },
    submitForm(reason) {
      this.form.reason = reason;
      axios.post(window.location.pathname, this.form)
        .then(data => {
          window.location.href = window.location.pathname + '/' + data.data.appraisal;
        })
        .catch(e => {
          this.formErrors = e.response?.data?.errors;
          displayCustomIconToast('error', {
            props: {
              type: 'error',
              title: e.response?.data?.errors ?? 'Se ha producido un error al realizar la tasación.',
              timeout: 7000,
            },
          });
        });
    },
    setProperties({ data }) {
      this.propertiesData = data.properties;
    },
    mountGoogleAutocomplete() {
      loadGoogleMaps(() => {
        const input = document.getElementById('addressField').getElementsByTagName('input')[0];
        const options = {
          componentRestrictions: { country: 'es' },
          fields: ['formatted_address'],
          types: ['address'],
        };
        const autocomplete = new google.maps.places.Autocomplete(input, options);

        autocomplete.addListener('place_changed', () => {
          this.form.address = autocomplete.getPlace().formatted_address;
        });
      });
    },
    fetchTown(event) {
      if (!!event) {
        this.formErrors = null;
        if (!this.form.addressSearch && event.length < 16) {
          return;
        }

        const form = this.$refs.form;
        axios
          .patch(route('appraisal.fetch.town'), {
            addressSearch: this.form.addressSearch,
            ...(this.form.addressSearch ? { address: event } : { ref: event }),
          })
          .then(data => {
            form.setFieldValue('town', data.data?.town);
          })
          .catch(e => {
            form.setFieldValue('town', null);
            this.formErrors = e.response?.data?.errors;
          });
      }
    },
  },
};
</script>
<style>
.pac-container {
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  margin-top: 0.75rem;
  box-shadow: 0 1rem 2.25rem rgba(209, 213, 219, 0.23);
}
.pac-icon {
  display: none;
}
.pac-item {
  font-size: 1.125rem;
  font-family: 'Roboto';
  padding: 0.75rem 1.5rem;
  border: none;
}
.pac-item:hover {
  cursor: pointer;
}
.pac-item-query {
  font-size: 1.125rem;
  font-family: 'Roboto';
}
.pac-matched {
  font-weight: 400;
}
</style>
